<template>
	<div>
		  <Breadcrumbs main="Staffs" title="Add Staff" />
			 <div class="container-fluid">
				<div class="row">
				   <div class="col-sm-12">
					  <div class="card">
						 <div class="card-body">
 
							<div class="row mb-3">
							   	<div class="col-12">
									<router-link to="/staffs" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
							   	</div>
							</div>
 
							<form @submit.prevent="addStaff" enctype="multipart/form-data">
								<div class="form theme-form">
									<div class="row">
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Staff Name<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="name"/>
												<span class="validate-error" v-if="errors.name">
													{{ errors.name[0] }}
												</span>
											</div>
										</div>

                                        <div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Username<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="username"/>
												<span class="validate-error" v-if="errors.user_name">
													{{ errors.user_name[0] }}
												</span>
											</div>
										</div>

                                        <div class="col-md-4 form-group">
                                            <label class="control-label">Mobile No.<span class="text-danger">*</span></label>
                                            <input class="form-control" type="number" placeholder="" v-model="mobile" @input="restrictMobileInput" minlength="10" maxLength="10"/>
											<span class="validate-error" v-if="errors.mobile">
												{{ errors.mobile[0] }}
											</span>
                                        </div>
									
										<div class="col-md-4">
											<div class="mb-3">
												<label class="control-label">Email<span class="text-danger">*</span></label>
												<input class="form-control" type="text" placeholder="" v-model="email"/>
												<span class="validate-error" v-if="errors.email">
													{{ errors.email[0] }}
												</span>
											</div>
										</div>

										<div class="col-md-4">
											<div class="mb-3">
												 <label class="control-label">Password<span class="text-danger">*</span></label>
                                                <input class="form-control" type="password" placeholder="" v-model="password"/>
												<span class="validate-error" v-if="errors.password">
													{{ errors.password[0] }}
												</span>
											</div>
										</div>

                                        <div class="col-md-4">
											<div class="mb-3">
												 <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                                                <input class="form-control" type="text" placeholder="" v-model="password_confirmation"/>
												<span class="validate-error" v-if="errors.password_confirmation">
													{{ errors.password_confirmation[0] }}
												</span>
											</div>
										</div>
									</div>
								</div>

                                <div class="row mt-3">
									<div class="col-sm-12">
										<button class="btn btn-success me-2 float-end" type="submit">Save</button>
									</div>
								</div>

							</form>
						 </div>
					  </div>
				   </div>
				</div>
			</div>
 
	</div>
 </template>

<script setup>
import { get, post } from '@/utils/api';
import { routes } from '@/constants/routes';
import Swal from '@/utils/swal';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import 'core-js/modules/es.array.includes'; 
import { goBack } from '@/utils/urlHider';

const router = useRouter();

const name = ref("");
const mobile = ref("");
const email = ref("");
const username = ref("");
const password = ref("");
const password_confirmation = ref(""); 
const errors = ref({});
				
const restrictMobileInput = (event) => {
	// Remove any non-digit characters and limit to 10 digits
	const value = event.target.value.replace(/\D/g, '').slice(0, 10);
	mobile.value = value;
};

const addStaff = () => {

    const formData = new FormData();
    formData.append('name', name.value);
    formData.append('user_name', username.value);
    formData.append('mobile', mobile.value);
    formData.append('password', password.value);
    formData.append('password_confirmation', password_confirmation.value);
    formData.append('email', email.value);

	post(routes.AddStaff, formData, false)
		.then((response) => {
			if (response.status === 200) {
                Swal.fire('', response.data.message || 'Staff added successfully', 'success');
				router.push({ name: 'staffs'});
            } else {
                Swal.fire('', response.data.message || 'Failed to add staff', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                errors.value = error.response.data.message;
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});

};

const handleGoBack = () => {
	const success = goBack(router);
	if (!success) {
		// If no history, go to dashboard as fallback
		router.push({ name: 'defaultRoot' });
	}
};

</script>